import { useEffect, useState } from 'react';
import './SessionExpiredOverlay.css';

function SessionExpiredOverlay() {
    const [visible, setVisible] = useState(false);
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const handleSessionExpired = () => {
            setVisible(true);
        };
        window.addEventListener('session-expired', handleSessionExpired);
        return () => window.removeEventListener('session-expired', handleSessionExpired);
    }, []);

    useEffect(() => {
        if (!visible) return;

        setCountdown(5);
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    window.location.href = '/auth/signin';
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [visible]);

    if (!visible) return null;

    return (
        <div className="session-overlay">
            <div className="session-card">
                <div className="session-icon-wrap">
                    <div className="session-icon-ring">
                        <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#f59e0b" strokeWidth="2"/>
                            <path d="M12 8V12" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round"/>
                            <circle cx="12" cy="16" r="1.2" fill="#f59e0b"/>
                        </svg>
                    </div>
                </div>

                <h4 className="session-title">Session Expired</h4>
                <p className="session-desc">
                    Your account was just signed in from another device.<br />
                    For your security, this session has been automatically closed.
                </p>

                <div className="session-countdown-wrap">
                    <svg className="session-countdown-ring" viewBox="0 0 60 60">
                        <circle cx="30" cy="30" r="26" stroke="#f3f4f6" strokeWidth="4" fill="none" />
                        <circle
                            cx="30" cy="30" r="26"
                            stroke="#f59e0b"
                            strokeWidth="4"
                            fill="none"
                            strokeDasharray={`${2 * Math.PI * 26}`}
                            strokeDashoffset={`${2 * Math.PI * 26 * (1 - countdown / 5)}`}
                            strokeLinecap="round"
                            style={{ transition: 'stroke-dashoffset 1s linear', transform: 'rotate(-90deg)', transformOrigin: 'center' }}
                        />
                    </svg>
                    <span className="session-countdown-num">{countdown}</span>
                </div>

                <p className="session-redirect-hint">Automatically redirecting to login in <strong>{countdown}s</strong></p>

                <button
                    className="session-btn"
                    onClick={() => { window.location.href = '/auth/signin'; }}
                >
                    Sign in again
                </button>
            </div>
        </div>
    );
}

export default SessionExpiredOverlay;
